module.exports = __webpack_public_path__ + "static/img/new-home-item2.22d7fed0.jpg";